/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc)
 */
 
import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { FamilyMemberBase } from 'shared/dbo/FamilyMember';

export interface FamilyMemberIndexedDb {
	id: string;
	firstName: string;
	portionCategoryId: string;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isFamilyMemberIndexedDb = (obj: unknown): obj is FamilyMemberIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ firstName: unknown }>(obj, 'firstName') || !(typeof obj.firstName === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ portionCategoryId: unknown }>(obj, 'portionCategoryId') || !(typeof obj.portionCategoryId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: FamilyMemberBase): FamilyMemberIndexedDb => ({
	id: obj.id.toString(),
	firstName: obj.firstName,
	portionCategoryId: obj.portionCategoryId.toString(),
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: FamilyMemberIndexedDb): FamilyMemberBase => ({
	id: UUID.fromString(obj.id),
	firstName: obj.firstName,
	portionCategoryId: UUID.fromString(obj.portionCategoryId),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdFamilyMember: LocalDatabaseTableDefinition<FamilyMemberBase, FamilyMemberIndexedDb> = {
	tableName: 'familyMembers',
	indexColumns: [],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
